import React, { Fragment, useMemo } from 'react';
import _get from 'lodash/get';
import _size from 'lodash/size';
import _isArray from 'lodash/isArray';
import styles from './index.module.scss';

import { If } from 'utils';
import { LineBreak, UiKit } from 'components';

export default function CarrierServices({
  slas = [],
  data = {},
  errors = {},
  onChange = () => {},
  isDisabled = false
}) {
  const value = _get(data, 'slas', []);
  const error = _get(errors, 'slas', '');
  const areAllSelected = _size(value) === _size(slas);

  const slasMap = useMemo(() => {
    if (!_isArray(slas)) return {};
    return slas.reduce((acc, sla) => {
      const id = _get(sla, 'id', '');
      acc[id] = true;
      return acc;
    }, {});
  }, [slas]);

  const onToggle = id => {
    const slas = { ..._get(data, 'slas', {}) };
    if (id in slas) {
      delete slas[id];
    } else {
      slas[id] = true;
    }
    onChange({ slas });
  };

  const onToggleAll = value => {
    const slas = value ? { ...slasMap } : {};
    onChange({ slas });
  };

  const slasList = slas.map((sla, slaIndex) => {
    const id = _get(sla, 'id', '');
    const slaName = _get(sla, 'name', '');
    const isActive = _get(value, id, false);
    const addLineBreak = !(slaIndex === slas.length - 1);

    return (
      <Fragment key={id}>
        <div className={styles.sla}>
          <UiKit.Checkbox
            label={slaName}
            checked={isActive}
            disabled={isDisabled}
            onChange={() => onToggle(id)}
          />
        </div>
        <If test={addLineBreak}>
          <LineBreak marginTop="5px" marginBottom="5px" />
        </If>
      </Fragment>
    );
  });

  return (
    <UiKit.Grid templateColumns="1fr" gap="16">
      <p className={styles.title}>Services</p>
      <UiKit.Grid templateColumns="1fr" gap="16">
        <div className={styles.row}>
          <UiKit.Checkbox
            label="Select all"
            checked={areAllSelected}
            onChange={onToggleAll}
            disabled={isDisabled}
            className={styles.selectAll}
          />
          <UiKit.Error msg={error} className="m-0" />
        </div>
        <div className={styles.slas} data-error={!!error}>
          {slasList}
        </div>
      </UiKit.Grid>
    </UiKit.Grid>
  );
}
